/* eslint-disable react/prop-types */
import { useState, useEffect } from 'react';
import { 
  Modal, 
  ModalHeader, 
  ModalBody, 
  ModalFooter, 
  Button, 
  ListGroup, 
  ListGroupItem,
  Input
} from 'reactstrap';
import { FaExternalLinkAlt } from 'react-icons/fa';

const LISTA_REDES_SOCIAIS = ["Instagram", "YouTube", "Facebook", "Tiktok", "Kwai", "Threads", "Twitter/X"];

function ModalListaDeRedes({ isOpen, toggle, redes, onSave }) {
  const [redesEditaveis, setRedesEditaveis] = useState([]);

  useEffect(() => {
    const redesExistentes = redes || [];

    const listaCompleta = LISTA_REDES_SOCIAIS.map(nomeRede => {
      const redeEncontrada = redesExistentes.find(r => r.rede === nomeRede);

      return {
        rede: nomeRede,
        link: redeEncontrada ? redeEncontrada.link : ''
      };
    });

    setRedesEditaveis(listaCompleta);
  }, [redes, isOpen]);

  const handleLinkChange = (e, index) => {
    const novasRedes = [...redesEditaveis];
    novasRedes[index].link = e.target.value;
    setRedesEditaveis(novasRedes);
  };

  const handleSalvar = () => {
    if (onSave) {
      const redesParaSalvar = redesEditaveis.filter(rede => rede.link && rede.link.trim() !== '');
      onSave(redesParaSalvar);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Redes Sociais Cadastradas</ModalHeader>
      <ModalBody>
        <ListGroup style={{ display: 'flex', gap: 15 }}>
          {redesEditaveis.map((item, index) => (
            <ListGroupItem key={index} style={{
                 display: 'flex', 
                 flexDirection: 'column',
                 gap: 10
                }}>
                <strong>{item.rede}:</strong>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <Input
                    type="text"
                    value={item.link}
                    placeholder={`https://www.${item.rede.toLowerCase()}.com/...`}
                    onChange={(e) => handleLinkChange(e, index)}
                  />
                  {item.link && (
                    <a href={item.link} target="_blank" rel="noopener noreferrer" title="Acessar link">
                      <FaExternalLinkAlt size={20} color="#0d6efd" style={{ cursor: 'pointer' }}/>
                    </a>
                  )}
                </div>
            </ListGroupItem>
          ))}
        </ListGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleSalvar}>
          Salvar Alterações
        </Button>
        <Button color="secondary" onClick={toggle}>
          Fechar
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default ModalListaDeRedes;